import React, { useEffect, useState, useCallback,useRef, useContext } from "react";
import { useLocation, useHistory } from "react-router-dom";
import Pagination from "react-js-pagination";
import Moment from "react-moment";
import moment from "moment";
import ProjectContext from "../../ProjectContext.js";
import {
  Button,
  Card,
  CardHeader,
  ModalBody,
  Modal,
  Form,
  CardFooter,
  CardTitle,
  Input,
  Table,
  Container,
  Row,
  Col,
  Spinner,
} from "reactstrap";
import Select from "react-select";
import ReactDatetime from "react-datetime";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfo, faTimes } from "@fortawesome/free-solid-svg-icons";
import ReactBSAlert from "react-bootstrap-sweetalert";
import transactionsService from "../../services/api/transaction-membership-service";
import projectUsersService from "../../services/api/project-users-service";
  
  const RECORDS_PER_PAGE = 10;
  
  const createAlert = (type, message) => (
    <ReactBSAlert
      type={type}
      style={{ display: "block", marginTop: "-100px" }}
      title={type === "error" ? "Error" : "Success"}
      onConfirm={() => {}}
      onCancel={() => {}}
      confirmBtnBsStyle="success"
      confirmBtnText="OK"
      btnSize=""
    >
      {message}
    </ReactBSAlert>
  );
  
  const MembershipTransaction = ({ projectId, user_id, pg_subscription_id }) => {
 
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedTransaction, setSelectedTransaction] = useState(null);
    const [transactions, setTransactions] = useState([]);
    const [totalTransactions, setTotalTransactions] = useState(0);
    const [isLoading, setIsLoading] = useState(true);
    const [alert, setAlert] = useState(null);
    const [activePage, setActivePage] = useState(1);
    
  
    const formStateRef = useRef({
      project_id: projectId,
      user_id: user_id,
      pg_subscription_id: pg_subscription_id
    });
    

    useEffect(() => {
      formStateRef.current = {
        project_id: projectId,
        user_id: user_id,
        pg_subscription_id: pg_subscription_id
      };
      

      setActivePage(1);
      
   
      fetchTransactions(1);
    }, [projectId, user_id, pg_subscription_id]);
  
  
    const fetchTransactions = useCallback(async (page = activePage) => {
      setIsLoading(true);
      try {
     
        const filters = formStateRef.current;
        
        const response = await transactionsService.getTransactions(
          filters,
          page,
          RECORDS_PER_PAGE
        );
        
        if (response.status && response.data) {
          setTransactions(response.data);
          const totalCount = await transactionsService.getTotalTransactions(filters);
          if (totalCount.status) {
            setTotalTransactions(totalCount.data.count);
          }
        }
      } catch (error) {
        console.error("Error fetching transactions:", error);
        setAlert(createAlert("error", "Failed to fetch transactions"));
      } finally {
        setIsLoading(false);
      }
    }, []);
  

    const handlePageChange = useCallback((pageNumber) => {
      setActivePage(pageNumber);
      fetchTransactions(pageNumber);
    }, [fetchTransactions]);
  
    const handleOpenModal = useCallback((transaction) => {
      setSelectedTransaction(transaction);
      setModalOpen(true);
    }, []);
  
    const handleCloseModal = useCallback(() => {
      setModalOpen(false);
      setSelectedTransaction(null);
    }, []);
  
    const getStatusText = (status) => {
      switch (status) {
        case 0:
          return "Initiated";
        case -1:
          return "Order could not created";
        case 2:
          return "Success";
        case -2:
          return "Failed";
        default:
          return "";
      }
    };
  
  
    useEffect(() => {
      fetchTransactions(1);
    }, []);
  
    const renderTransactionRows = () => {
      if (isLoading) {
        return (
          <tr>
            <td colSpan="8" className="text-center">
              <Spinner animation="border" role="status">
                <span className="sr-only">Loading...</span>
              </Spinner>
            </td>
          </tr>
        );
      }
  
      if (!transactions.length) {
        return (
          <tr>
            <td colSpan="8" className="text-center">
              <CardTitle tag="h4">No Records Found</CardTitle>
            </td>
          </tr>
        );
      }
  
      return transactions.map((transaction, index) => {
        const rowNumber = RECORDS_PER_PAGE * (activePage - 1) + index + 1;
  
        return (
          <tr key={transaction.id}>
            <td className="text-left">{rowNumber}</td>
            <td className="text-left">
              {transaction?.user_id?.email ||
                transaction?.user_id?.phone_number ||
                "-"}
            </td>
            <td className="text-left">{transaction?.currency === "INR" ? "₹" : "$"}{(transaction?.amount || 0) / 100}</td>
            <td className="text-left">
              {transaction?.subscription_id?.pg_subscription_id || "-"}
            </td>
            <td className="text-left">{transaction.pg_txn_id || "-"}</td>
            <td className="text-left">
              <Moment format="DD MMM YYYY, hh:mm A">
                {transaction.createdat}
              </Moment>
            </td>
            <td className="text-left">
              {transaction.type === "1" ? "One time" : "Recurring"}
            </td>
            <td className="text-left">{getStatusText(transaction.status)}</td>
            <td>
              <Button
                color="info"
                size="sm"
                onClick={() => handleOpenModal(transaction)}
              >
                <FontAwesomeIcon icon={faInfo} />
              </Button>
            </td>
          </tr>
        );
      });
    };

  
  
    return (
      <div className="content" mt="4">
        {alert}
              {totalTransactions > 0 ? (
                <Row>
                  <Col md="6" >
                    <div style={{ float: "right", margin: "5px" }}>
                      <b>
                        {" "}
                        {(activePage - 1) * RECORDS_PER_PAGE + 1} -{" "}
                        {Math.min(
                          activePage * RECORDS_PER_PAGE,
                          totalTransactions
                        )}{" "}
                        of {totalTransactions}
                      </b>
                    </div>
                  </Col>
                  <Col md="6">
                    <div style={{ float: "left" }}>
                      <Pagination
                        activePage={activePage}
                        itemsCountPerPage={RECORDS_PER_PAGE}
                        totalItemsCount={totalTransactions}
                        pageRangeDisplayed={3}
                        onChange={handlePageChange}
                        itemClass="page-item"
                        linkClass="page-link"
                      />
                    </div>
                  </Col>
                </Row>
              ) : null}
  
              <Table responsive>
                <thead className="text-primary">
                  <tr>
                    <th className="text-left">#</th>
                    <th className="text-left">User Email or Phone No.</th>
                    <th className="text-left">Transaction Amount</th>
                    <th className="text-left">Membership ID</th>
                    <th className="text-left">Transaction Id</th>
                    <th className="text-left">Transaction Date</th>
                    <th className="text-left">Type</th>
                    <th className="text-center">Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>{renderTransactionRows()}</tbody>
              </Table>
              <Modal
                isOpen={modalOpen}
                toggle={() => setModalOpen(false)}
                size="md"
              >
                <ModalBody className="p-3 position-relative">
                  {/* Close Button */}
                  <div
                    className="position-absolute d-flex align-items-center justify-content-center"
                    style={{
                      right: "12px",
                      top: "8px",
                      cursor: "pointer",
                      zIndex: 1,
                      backgroundColor: "red",
                      borderRadius: "50%",
                      width: "25px",
                      height: "25px",
                    }}
                    onClick={() => setModalOpen(false)}
                  >
                    <FontAwesomeIcon icon={faTimes} className="text-white" />
                  </div>
  
                  {/* Transaction Details Section */}
                  <div className="mb-3">
                    <h6 className="mb-2">Transaction Details</h6>
                    <div className="border rounded">
                      <Row className="g-0">
                        <Col xs="5" className="p-2 bg-light">
                          <div className="fw-semibold text-dark">
                            Transaction ID
                          </div>
                        </Col>
                        <Col className="p-2">
                          <div className="fw-semibold">
                            {selectedTransaction?.id || "-"}
                          </div>
                        </Col>
                      </Row>
                      <Row className="g-0 border-top">
                        <Col xs="5" className="p-2 bg-light">
                          <div className="fw-semibold text-dark">Order ID</div>
                        </Col>
                        <Col className="p-2">
                          <div className="fw-semibold">
                            {selectedTransaction?.order_id || "-"}
                          </div>
                        </Col>
                      </Row>
                      <Row className="g-0 border-top">
                        <Col xs="5" className="p-2 bg-light">
                          <div className="fw-semibold text-dark">
                            PG Transaction ID
                          </div>
                        </Col>
                        <Col className="p-2">
                          <div className="fw-semibold">
                            {selectedTransaction?.pg_txn_id || "-"}
                          </div>
                        </Col>
                      </Row>
                      <Row className="g-0 border-top">
                        <Col xs="5" className="p-2 bg-light">
                          <div className="fw-semibold text-dark">
                            PG Transaction Message
                          </div>
                        </Col>
                        <Col className="p-2">
                          <div className="fw-semibold">
                            {selectedTransaction?.pg_txn_message || "-"}
                          </div>
                        </Col>
                      </Row>
                      <Row className="g-0 border-top">
                        <Col xs="5" className="p-2 bg-light">
                          <div className="fw-semibold text-dark">Amount</div>
                        </Col>
                        <Col className="p-2">
                          <div className="fw-semibold">
                            {selectedTransaction?.currency === "INR" ? "₹" : "$"}{selectedTransaction?.amount / 100 || "-"}
                          </div>
                        </Col>
                      </Row>
                      <Row className="g-0 border-top">
                        <Col xs="5" className="p-2 bg-light">
                          <div className="fw-semibold text-dark">Status</div>
                        </Col>
                        <Col className="p-2">
                          <div className="fw-semibold">
                            {getStatusText(selectedTransaction?.status)}
                          </div>
                        </Col>
                      </Row>
                      <Row className="g-0 border-top">
                        <Col xs="5" className="p-2 bg-light">
                          <div className="fw-semibold text-dark">
                            Transaction Date
                          </div>
                        </Col>
                        <Col className="p-2">
                          <div className="fw-semibold">
                            <Moment format="DD MMM YYYY, hh:mm A">
                              {selectedTransaction?.createdat}
                            </Moment>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </div>
  
                  <div>
                    <h6 className="mb-2">Membership Details</h6>
                    <div className="border rounded">
                      <Row className="g-0">
                        <Col xs="5" className="p-2 bg-light">
                          <div className="fw-semibold text-dark">
                            Membership ID
                          </div>
                        </Col>
                        <Col className="p-2">
                          <div className="fw-semibold">
                            {selectedTransaction?.subscription_id
                              ?.pg_subscription_id || "-"}
                          </div>
                        </Col>
                      </Row>
                      <Row className="g-0 border-top">
                        <Col xs="5" className="p-2 bg-light">
                          <div className="fw-semibold text-dark">Paid Count</div>
                        </Col>
                        <Col className="p-2">
                          <div className="fw-semibold">
                            {selectedTransaction?.subscription_id?.paid_count ||
                              "-"}
                          </div>
                        </Col>
                      </Row>
                      <Row className="g-0 border-top">
                        <Col xs="5" className="p-2 bg-light">
                          <div className="fw-semibold text-dark">Status</div>
                        </Col>
                        <Col className="p-2">
                          <div className="fw-semibold">
                            {selectedTransaction?.subscription_id?.status || "-"}
                          </div>
                        </Col>
                      </Row>
                      <Row className="g-0 border-top">
                        <Col xs="5" className="p-2 bg-light">
                          <div className="fw-semibold text-dark">Type</div>
                        </Col>
                        <Col className="p-2">
                          <div className="fw-semibold">
                          {selectedTransaction?.subscription_id?.type
                          ? selectedTransaction?.subscription_id?.type === "onetime"
                            ? "One Time"
                            : "Recurring"
                          : selectedTransaction?.subscription_id?.total_count === 1
                          ? "One Time"
                          : selectedTransaction?.subscription_id?.total_count
                          ? "Recurring"
                          : "N/A"}
                          </div>
                        </Col>
                      </Row>
                      <Row className="g-0 border-top">
                        <Col xs="5" className="p-2 bg-light">
                          <div className="fw-semibold text-dark">Share Url</div>
                        </Col>
                        <Col className="p-2">
                          <div className="fw-semibold">
                            {selectedTransaction?.subscription_id?.share_url ||
                              "-"}
                          </div>
                        </Col>
                      </Row>
                      <Row className="g-0 border-top">
                        <Col xs="5" className="p-2 bg-light">
                          <div className="fw-semibold text-dark">
                            Membership Start Date
                          </div>
                        </Col>
                        <Col className="p-2">
                          <div className="fw-semibold">
                            {selectedTransaction?.subscription_id?.start_at
                              ? moment
                                  .unix(
                                    selectedTransaction?.subscription_id?.start_at
                                  )
                                  .format("DD MMM YYYY, hh:mm A")
                              : "-"}
                          </div>
                        </Col>
                      </Row>
                      <Row className="g-0 border-top">
                        <Col xs="5" className="p-2 bg-light">
                          <div className="fw-semibold text-dark">
                            Membership End Date
                          </div>
                        </Col>
                        <Col className="p-2">
                          <div className="fw-semibold">
                            {selectedTransaction?.subscription_id?.end_at
                              ? moment
                                  .unix(
                                    selectedTransaction?.subscription_id?.end_at
                                  )
                                  .format("DD MMM YYYY, hh:mm A")
                              : "-"}
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </ModalBody>
              </Modal>
           
          
       
      </div>
    );
  };
  
  export default MembershipTransaction;